import React from "react";

import Header from "../components/Header";
import Footer from "../components/Footer";

import "./AboutUs.css";


function AboutUs() {

  return (
    <>
      <Header />

      <main className="about-page">

        {/* =====================================================
            ABOUT HERO
        ===================================================== */}

        <section className="about-hero">

          <div className="container">

            <div className="about-hero-content">

              <span className="about-badge">
                ABOUT HOMEOEADDA
              </span>

              <h1>
                About
              </h1>

              <p>
                “Homoeoadda-Ocean of MCQ’S &amp; homoeopathy education.”
              </p>

            </div>

          </div>

        </section>


        {/* =====================================================
            ABOUT CONTENT
        ===================================================== */}

        <section className="about-content-section">

          <div className="container">

            <div className="about-content-card">

              {/* About */}

              <div className="about-section">

                <h2>
                  About
                  <br />
                  <strong>
                    “Homoeoadda-Ocean of MCQ’S &amp; homoeopathy education.”
                  </strong>
                </h2>

                <p>
                  In India, lacs of students every year appear in different competitive exams of Homoeopathy but only a handful of them achieve the end results.
                </p>

              </div>


              {/* The Reason */}

              <div className="about-section">

                <h2 className="section-heading-center">
                  <strong>
                    The Reason
                  </strong>
                </h2>

                <p>
                  It’s because almost 95% of these exam aspirants
                  <br />
                  First,they don’t know how to face real exam environment ,They don’t know where to focus. Due to sheer negligence, they end up building command on most irrelevant or un-important questions.
                  <br />
                  Second, many a student is not able to understand the difference between an ‘actually’ difficult question and a ‘seemingly’ difficult one. If simply put, they tend to leave a good number of questions un-attempted considering them too hard to crack while the questions can easily be solved using a right approach and that’s too in 50-60% less time than they earlier attempted to solve them in.
                </p>

              </div>


              {/* How HomoeoAdda Helps */}

              <div className="about-section">

                <h2 className="section-heading-center">
                  <strong>
                    How HOMOEOADDA Helps
                  </strong>
                </h2>

                <p>
                  HOMOEOADDA is an first digital advanced step in the field of Homoeopathy started in year 2018,successfully running different test series with trustworthy selections in different colleges in post graduate courses, providing a platform to crack any Post Graduate Entrance or Homoeopathy competitive exams on your finger tips in a non stressful and user friendly way.
                </p>

                <p>
                  It offers a smart way to solve a problem that is most likely to come in the exam but ‘seems’ complex to many. In simple words, you’ll smartly be able to answer those specific questions which are crucial and are being skipped by other students and that’s where you can get an upper-hand over your peers.
                </p>

                <p>
                  With first-hand experiences of cracking AIAPGET and UPSC examinations in India and constant analysis of the Homoeopathy based exams being conducted at college, state and national levels across India,Team Homoeoadda members have a fair idea of how to help you gain genuine understanding of a topic and what tips to give you to optimize your score in particular Homoeopathy entrance exams you are targeting.Homoeadda team having numerous dynamic souls helping budding homoeopaths in achieving their targets.
                </p>

                <p>
                  HOMOEOADDA believes in #DYNAMIC EXISTENCE ,OUR MOTTO IS ONLY TO PROMOTE HOMOEOPATHY IS IT’S PURE REFINED FORM &amp; HELP HOMOEOPATH IN ACHIEVING THEIR GOALS…………….
                </p>

                <p className="about-final-text">
                  <strong>
                    JAI HAHNEMANN JAI HOMOEOPATHY
                  </strong>
                </p>

              </div>

            </div>

          </div>

        </section>

      </main>

      <Footer />
    </>
  );

}


export default AboutUs;